import {
  COMPANY_SEARCH_REQUESTED,
  COMPANY_SEARCH_RECEIVED,
  COMPANY_SEARCH_ERROR,
} from './actionTypes';

// import { getCompanies } from "../../api/mockApiCall";
import { getCompanies } from '../../api';

export const getCompaniesDispatcher = dispatch => term => {
  dispatch({
    type: COMPANY_SEARCH_REQUESTED,
  });

  getCompanies(term)
    .then(data => {
      dispatch({
        type: COMPANY_SEARCH_RECEIVED,
        payload: data.items,
      });
    })
    .catch(err => {
      dispatch({
        type: COMPANY_SEARCH_ERROR,
        payload: err,
      });
    });
};



// WEBPACK FOOTER //
// ./AutoComplete/context/actionDispatchers.js